(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brass-product-information"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#brass-order-"]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (target && target.matches('details[data-brass-making]')) target.open = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["portrait-comparison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('portrait-comparison')) {
    customElements.define('portrait-comparison', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const range = this.querySelector('input');
        const stage = this.querySelector('.portrait-comparison__stage');
        const update = () => this.style.setProperty('--comparison-position', `${range.value}%`);
        const move = (event) => {
          const rect = stage.getBoundingClientRect();
          range.value = Math.round(Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100)));
          update();
        };
        let pointerId = null;
        range.hidden = false;
        range.addEventListener('input', update);
        range.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0) return;
          event.preventDefault();
          pointerId = event.pointerId;
          range.focus({ preventScroll: true });
          range.setPointerCapture(pointerId);
          move(event);
        });
        range.addEventListener('pointermove', (event) => {
          if (event.pointerId === pointerId) move(event);
        });
        const stop = () => { pointerId = null; };
        range.addEventListener('pointerup', stop);
        range.addEventListener('pointercancel', stop);
        range.addEventListener('lostpointercapture', stop);
        update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-reviews')) {
    customElements.define('product-reviews', class extends HTMLElement {
      connectedCallback() {
        const widget = this.querySelector('.jdgm-review-widget');
        if (!widget) return;
        this.resizeObserver = new ResizeObserver(() => {
          this.toggleAttribute('data-ready', widget.getBoundingClientRect().height > 0);
        });
        this.resizeObserver.observe(widget);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
